export interface ProgramPromotionCode {
	Id: number;
	ProgramId: number|null;
	ProgramGroupId: number[]|null;
	Code: string;
	Description: string;
	ValidFrom: string|null;
	ValidTo: string|null;
	DiscountType: ProgramPromotionCodeDiscountType;
	DiscountAmount: number;
	LimitQuantity: number|null;
	Deleted: boolean;
}

export enum ProgramPromotionCodeDiscountType {
	Amount = 1,
	Percent = 2
}